export const START_LOAD = 'event/START_LOAD';
export const FINISH_LOAD = 'event/FINISH_LOAD';

const initialState = {
    loading:false,
    event:null
};
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case START_LOAD:  return {...state, loading:true};
        case FINISH_LOAD:  return {...state, loading:false, event:action.payload};
        default: return state;
    }
}